import { DatePicker } from 'antd'
import moment from 'moment'
import { PropertyValue, Property } from 'api/clients/PropertyClient'
import Styles from '../PropertyValue.module.scss'
import { useLayoutEffect, useRef, useState } from 'react'
import { useKey } from 'react-use'
import {
  SelectPropertyEventDetails,
  selectPropertyEventName,
} from 'screens/Finder/components/FileTree/events/selectProperty'

interface Props {
  property: Property
  propertyValue?: PropertyValue
  onCreate?: (propertyValue: PropertyValue) => void
  onUpdate?: (propertyValue: PropertyValue) => void
  onCancel?: () => void
}
const formatDate = (date: moment.Moment | null) => {
  if (!date) return ''

  return moment(date).format('YYYY-MM-DD')
}

export const DateEdit = ({ property, propertyValue, onCreate, onUpdate, onCancel }: Props) => {
  const [isOpen, setIsOpen] = useState(true)
  const calendarContainerRef = useRef<HTMLSpanElement>()
  const handleDateChange = (date: moment.Moment | null) => {
    if (propertyValue) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      onUpdate!({
        ...propertyValue,
        value: formatDate(date),
      })
    } else {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      onCreate!({
        value: formatDate(date),
        property_id: property.id,
      } as PropertyValue)
    }
  }
  useKey(
    'Escape',
    () => {
      onCancel?.()
    },
    { options: true },
  )

  useKey(
    'Enter',
    () => {
      setTimeout(() => {
        document.body.dispatchEvent(
          new CustomEvent<SelectPropertyEventDetails>(selectPropertyEventName, {
            bubbles: false,
            detail: 'Down',
          }),
        )
      }, 0)
    },
    { options: true },
  )

  useLayoutEffect(() => {
    setTimeout(() => {
      if (calendarContainerRef.current) {
        calendarContainerRef.current.querySelector<HTMLDivElement>('.ant-calendar-date-panel')?.focus()
      }
    }, 0)
  }, [])

  const getCalendarContainer = (trigger: Element) => {
    calendarContainerRef.current = trigger.parentNode as HTMLSpanElement
    return trigger.parentNode as HTMLSpanElement
  }

  return (
    <DatePicker
      onOpenChange={setIsOpen}
      open={isOpen}
      onChange={handleDateChange}
      getCalendarContainer={getCalendarContainer}
      showToday={false}
      value={propertyValue?.value ? moment(propertyValue?.value) : undefined}
      className={Styles.datePicker}
      dropdownClassName={Styles.datePickerDropDownClassName}
    />
  )
}
